export const SET_PAGES = "SET_PAGES";
export const SET_API = "SET_API";
export const SET_LANGUAGE = "SET_LANGUAGE";
